import api from '../../Axios'; // Adjust path to your Axios instance if needed

// We don't define an interface for payload here because it is 'FormData'
export const saveLawyerVerification = async (formData: FormData) => {
  return api.post('/api/experts/lawyer/verification', formData, {
    headers: {
      'Content-Type': 'multipart/form-data', // Crucial for file uploads
    },
  });
};